define('modules/lp_leads/views/navigation',['require','exports','module','base/layout','backbone','backbone','common/views/datepicker','ldsh!../templates/navigation'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    Backbone = require('backbone'),
    history = require('backbone').history,
    Datepicker = require('common/views/datepicker');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/navigation'),

    regions: {
      datepicker: '.js-datepicker',
    },

    triggers: {
      'click .js-datepicker-button': 'datepicker:toggle',
    },

    events: {
      'click .js-back': 'goBack',
    },

    constructor: function (options) {
      this.viewModel = options.filters;
      module.exports.__super__.constructor.apply(this, arguments);
    },

    goBack: function () {
      history.navigate('/info/' + this.model.get('id'), {
        replace: true,
        trigger: true,
      });
    },

    helpers: function () {
      return {
        name: this.model.get('name'),
      };
    },

    initialize: function (options) {
      var datepicker = new Datepicker({
        model: options.date,
        className: 'ed-stats-dateFilter ed-pages-filter hidden',
        viewToggler: this,
        buttonTranslationKey: 'landingPage.dialog.leadListing.downloadLeads',
        noLabel: true,
      });

      this.$datepicker.show(datepicker);
    },
    onRender: function () {
      this.$el.i18n();
    },
  });
});

